<label [attr.for]="inputId" class="phx-checkbox-label">
  <span class="phx-checkbox-mark-container">

    <input type="checkbox" class="phx-checkbox-input" [id]="inputId" [checked]="phxChecked" [attr.value]="phxValue"
      [attr.name]="phxName" [tabIndex]="tabIndex" [required]="phxRequired" [disabled]="disabled"
      [indeterminate]="phxIndeterminate" (change)="onChangeEvent($event)" #input />

    <span class="phx-checkbox-bordered-frame"></span>

    <span class="phx-checkbox-background"></span>
    
    <i *ngIf="phxChecked" phx-icon [phxIcon]="CheckUIIcon" [size]="16" color="white"></i>

    <i *ngIf="phxIndeterminate" phx-icon [phxIcon]="SubtractIcon" [size]="16" color="white"></i>
    
  </span>

  <span class="phx-checkbox-text" #checkboxLabelText>
    <ng-content></ng-content>
  </span>

</label>
